import { HotelReserveRoomsFilterItemPropertiesType } from "@website/accommodation-ui/hotel-reserve-rooms-filter/hotel-reserve-rooms-filter-item/hotel-reserve-rooms-filter-item.types";
import { MaterialIcon, MaterialNameType } from "@website/icons/material";
import { Button } from "@website/ui/button";
import { Checkbox } from "@website/ui/checkbox";
import { MiniPopover } from "@website/ui/mini-popover";
import { ToggleButton } from "@website/ui/toggle-button";
import { deepCompare } from "@website/utils/deep-compare";
import { numberConvert } from "@website/utils/number-convert";
import get from "lodash-es/get";
import omit from "lodash-es/omit";
import { useRouter } from "next/router";
import { memo, useState } from "react";

const Component = ({
  title,
  options,
  persianTitle,
  iconName,
  toggleList,
  type = "button",
  onClick
}: HotelReserveRoomsFilterItemPropertiesType) => {
  const router = useRouter();

  const [checkedItems, setCheckedItems] = useState(
    `roomFilter_${title}` in router.query
      ? String(router?.query?.[`roomFilter_${title}`])?.split("_")
      : []
  );
  const [openPopover, setOpenPopover] = useState(false);

  return (
    <div className="relative">
      {type === "toggle" && toggleList ? (
        <ToggleButton
          color="secondary"
          list={toggleList}
          onChange={(value) => {
            if (value === "all") onClick?.();
            return router.replace(
              {
                pathname: router.pathname,
                query: {
                  ...router.query,
                  [`roomFilter_${title}`]: value
                }
              },
              undefined,
              { shallow: true, scroll: false }
            );
          }}
          rounded
          size="small"
          value={
            toggleList?.find(
              ({ value }) => get(router.query, `roomFilter_${title}`) === value
            )?.value || toggleList?.[1]?.value
          }
          variant="round"
        />
      ) : (
        <Button
          EndIcon={
            options?.length ? (
              <MaterialIcon name="arrow_drop_down" />
            ) : router?.query?.[`roomFilter_${title}`] ? (
              <MaterialIcon className="text-subtitle-1" name="clear" />
            ) : null
          }
          StartIcon={
            <MaterialIcon
              className={`${
                router?.query?.[`roomFilter_${title}`]
                  ? "text-secondary"
                  : "text-on-surface-medium-emphasis"
              } text-body-1`}
              name={iconName as MaterialNameType}
              variant="outlined"
            />
          }
          className="truncate"
          color={
            router?.query?.[`roomFilter_${title}`] ? "secondary" : "neutral"
          }
          onClick={() => {
            if (options && options?.length > 0) {
              setOpenPopover(true);
              if (
                !checkedItems?.every(
                  (item) => options?.some((option) => option === item)
                )
              ) {
                setCheckedItems([]);
                return router.replace(
                  {
                    pathname: router.pathname,
                    query: omit(router?.query, `roomFilter_${title}`)
                  },
                  undefined,
                  { shallow: true, scroll: false }
                );
              }
            } else {
              `roomFilter_${title}` in router.query
                ? router.replace(
                    {
                      pathname: router.pathname,
                      query: omit(router?.query, `roomFilter_${title}`)
                    },
                    undefined,
                    { shallow: true, scroll: false }
                  )
                : router.replace(
                    {
                      pathname: router.pathname,
                      query: {
                        ...router.query,
                        [`roomFilter_${title}`]: "true"
                      }
                    },
                    undefined,
                    { shallow: true, scroll: false }
                  );
            }
          }}
          size="small"
          text={persianTitle}
          variant="round-outline"
        />
      )}
      <MiniPopover
        animate="bottom"
        className="right-0"
        defaultHorizontalPosition="end"
        onClose={() => setOpenPopover(false)}
        open={openPopover}
        title={persianTitle}
      >
        <div className="flex max-h-[500px] w-full flex-col overflow-y-auto px-6 pb-[100px]">
          {options?.map((item) => (
            <Checkbox
              checked={checkedItems?.some((value) => value === item)}
              className="py-3"
              color="secondary"
              label={item}
              name={item}
              onChange={(event) =>
                checkedItems?.some((item) => item === event?.target?.value)
                  ? setCheckedItems(
                      (previousState) =>
                        previousState?.filter(
                          (item) => item !== event?.target?.value
                        )
                    )
                  : setCheckedItems((previousState) => [
                      ...previousState,
                      event?.target?.value
                    ])
              }
              value={item}
            />
          ))}
          <div className="border-t-dim-surfaces fixed inset-x-0 bottom-0 flex flex-row justify-between border-t bg-white p-6">
            <Button
              color="primary"
              onClick={() => {
                setCheckedItems([]);
                return router.replace(
                  {
                    pathname: router.pathname,
                    query: omit(router?.query, `roomFilter_${title}`)
                  },
                  undefined,
                  { shallow: true, scroll: false }
                );
              }}
              text="پاک کردن"
              variant="text"
            />
            <Button
              color="secondary"
              onClick={() => {
                setOpenPopover(false);
                if (checkedItems?.length > 0)
                  return router.replace(
                    {
                      pathname: router.pathname,
                      query: {
                        ...router?.query,
                        [`roomFilter_${title}`]: checkedItems?.join("_")
                      }
                    },
                    undefined,
                    { shallow: true, scroll: false }
                  );
                return router.replace(
                  {
                    pathname: router.pathname,
                    query: omit(router?.query, `roomFilter_${title}`)
                  },
                  undefined,
                  { shallow: true, scroll: false }
                );
              }}
              text={
                checkedItems?.length > 0
                  ? `تایید انتخاب‌ها (${numberConvert(checkedItems?.length, {
                      locale: router?.locale
                    })})`
                  : "تایید انتخاب‌ها"
              }
            />
          </div>
        </div>
      </MiniPopover>
    </div>
  );
};
export const HotelReserveRoomsFilterItem = memo(Component, deepCompare);
